// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topup {
  cursor: pointer;
  display: flex; }
  .topup:hover {
    color: #f5f5f5; }
  .topup .topup-button {
    font-weight: 500;
    font-size: 14px; }

.light-border-color {
  border-color: #b1b1b1 !important; }

.table-container {
  min-height: 500px !important; }

.user-header {
  background: #1d2a32;
  padding: 10px 15px;
  border-radius: 5px;
  border: none;
  font-weight: 500;
  font-size: 20px; }
  .user-header .user-address {
    font-weight: 500;
    font-size: 18px; }

.overview-container {
  background: #273943;
  color: white;
  padding: 24px 24px;
  border-radius: 15px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px; }
  .overview-container .info-holder {
    background: #1d2a32;
    border-radius: 5px;
    padding: 10px 15px; }
    .overview-container .info-holder .info-header {
      color: #8de5e2;
      font-weight: 600;
      font-size: 14px; }
    .overview-container .info-holder .info-amount {
      margin-left: auto;
      font-weight: 400;
      font-size: 14px; }

.tag-group {
  border: none !important; }
  .tag-group .tab-button {
    border-radius: 5px !important;
    padding: 2px 15px !important;
    border: 1px solid #31545a !important;
    background-image: none !important;
    font-size: 12px; }
    .tag-group .tab-button.active {
      color: white !important;
      --bs-nav-tabs-link-active-bg: #31545a !important; }
    .tag-group .tab-button:hover:not(.active) {
      background: transparent !important; }

.tx-table td {
  max-width: none !important; }
`, "",{"version":3,"sources":["webpack://./src/components/UserDetail/style.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa,EAAA;EAFf;IAII,cAAc,EAAA;EAJlB;IAOI,gBAAgB;IAChB,eAAe,EAAA;;AAGnB;EACE,gCAAgC,EAAA;;AAElC;EACE,4BAA4B,EAAA;;AAG9B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe,EAAA;EANjB;IAQI,gBAAgB;IAChB,eAAe,EAAA;;AAInB;EACE,mBAAmB;EACnB,YAAY;EAEZ,kBAAkB;EAClB,mBAAmB;EAEnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA;EAVjB;IAaI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB,EAAA;IAftB;MAiBM,cAAc;MACd,gBAAgB;MAChB,eAAe,EAAA;IAnBrB;MAuBM,iBAAiB;MACjB,gBAAgB;MAChB,eAAe,EAAA;;AAKrB;EACE,uBAAuB,EAAA;EADzB;IAGI,6BAA6B;IAC7B,4BAA4B;IAC5B,oCAAoC;IACpC,iCAAiC;IACjC,eAAe,EAAA;IAPnB;MASM,uBAAuB;MACvB,gDAA6B,EAAA;IAVnC;MAaM,kCAAkC,EAAA;;AAKxC;EAEI,0BAA0B,EAAA","sourcesContent":[".topup {\n  cursor: pointer;\n  display: flex;\n  &:hover {\n    color: #f5f5f5;\n  }\n  .topup-button {\n    font-weight: 500;\n    font-size: 14px;\n  }\n}\n.light-border-color {\n  border-color: #b1b1b1 !important;\n}\n.table-container {\n  min-height: 500px !important;\n}\n\n.user-header {\n  background: #1d2a32;\n  padding: 10px 15px;\n  border-radius: 5px;\n  border: none;\n  font-weight: 500;\n  font-size: 20px;\n  .user-address {\n    font-weight: 500;\n    font-size: 18px;\n  }\n}\n\n.overview-container {\n  background: #273943;\n  color: white;\n\n  padding: 24px 24px;\n  border-radius: 15px;\n\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n\n  .info-holder {\n    background: #1d2a32;\n    border-radius: 5px;\n    padding: 10px 15px;\n    .info-header {\n      color: #8de5e2;\n      font-weight: 600;\n      font-size: 14px;\n    }\n\n    .info-amount {\n      margin-left: auto;\n      font-weight: 400;\n      font-size: 14px;\n    }\n  }\n}\n\n.tag-group {\n  border: none !important;\n  .tab-button {\n    border-radius: 5px !important;\n    padding: 2px 15px !important;\n    border: 1px solid #31545a !important;\n    background-image: none !important;\n    font-size: 12px;\n    &.active {\n      color: white !important;\n      --bs-nav-tabs-link-active-bg: #31545a !important;\n    }\n    &:hover:not(.active) {\n      background: transparent !important;\n    }\n  }\n}\n\n.tx-table {\n  td {\n    max-width: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
